export default __webpack_public_path__ + "static/media/alexa.03735e75.jpg";